export default "__VITE_ASSET__BzoFGykC__"